import * as Yup from 'yup'
import { reusableRightValidation } from '../../validation'

export const validationSchema = Yup.object({
  ...reusableRightValidation()
})
